module.exports = __webpack_public_path__ + "img/denti_i_logo_suwon.def5efe3.png";